export function dictationSupported() {
  return typeof window !== 'undefined' && !!(window.SpeechRecognition || window.webkitSpeechRecognition)
}

export function readingSupported() {
  return typeof window !== 'undefined' && !!window.speechSynthesis
}

export function speechLang(locale) {
  return String(locale || '').toLowerCase().startsWith('es') ? 'es-ES' : 'en-US'
}

export function startDictation({ lang, onText, onEnd, onError }) {
  const Ctor = window.SpeechRecognition || window.webkitSpeechRecognition
  if (!Ctor) {
    onError('unsupported')
    return { stop() {} }
  }
  const recognition = new Ctor()
  recognition.lang = speechLang(lang)
  recognition.interimResults = true
  recognition.continuous = false
  let stopped = false
  recognition.onresult = (event) => {
    let text = ''
    for (let index = 0; index < event.results.length; index += 1) {
      text += event.results[index][0].transcript
    }
    onText(text)
  }
  recognition.onerror = (event) => {
    const code = event && event.error
    if (code === 'not-allowed' || code === 'service-not-allowed') onError('denied')
    else if (code !== 'aborted' && code !== 'no-speech') onError('failed')
  }
  recognition.onend = () => {
    stopped = true
    onEnd()
  }
  try {
    recognition.start()
  } catch (error) {
    onError('failed')
    return { stop() {} }
  }
  return {
    stop() {
      if (!stopped) recognition.stop()
    },
  }
}

export function readAloud(text, lang, onEnd) {
  if (!readingSupported() || !String(text || '').trim()) return null
  window.speechSynthesis.cancel()
  const utterance = new SpeechSynthesisUtterance(String(text))
  utterance.lang = speechLang(lang)
  utterance.onend = () => {
    if (onEnd) onEnd()
  }
  window.speechSynthesis.speak(utterance)
  return {
    stop() {
      window.speechSynthesis.cancel()
      if (onEnd) onEnd()
    },
  }
}
